module.exports = __webpack_public_path__ + "static/media/mock-helvaci2.92b6b26e.png";